import React, { useEffect, useState } from "react"
import { MenuClient } from "../MenuClient"
import { Header } from "../../common/header/Header"
import { IMG } from "../../common/CONST"
import { IClientContractorDto } from "../../../types/contractor/IClientContractorDto"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { useNavigate } from "react-router-dom"
import Button from "@/ui/components/Button"
import { CLIENT_CONTRACTOR_NEW_ROUTE } from "@/routes"
import Skeleton from "@/ui/components/Skeleton"
import EmptyRow from "@/ui/components/EmptyRow"
import Input from "@/ui/components/Input"

export const ContractorListClient = () => {
  const navigate = useNavigate()

  const [contractors, setContractors] = useState<IClientContractorDto[]>([])
  const [filteredContractors, setFilteredContractors] = useState<IClientContractorDto[]>([])
  const [search, setSearch] = useState("")
  const [modalMessage, setModalMessage] = useState<IModalMessage>()
  const [isLoading, setLoading] = useState(true)

  const getContractors = () => {
    TrinityAPI.getClientContractors(
      response => {
        if (response.status === 200) {
          setContractors(response.data)
          setFilteredContractors(response.data)
        } else {
          setModalMessage({
            ...modalMessage,
            title: "Ошибка!",
            text: `Ошибка загрузки списка контрагентов: ${response.data.message}`
          })
        }
      },
      () => setLoading(false)
    )
  }

  useEffect(() => {
    if (!search) {
      setFilteredContractors(contractors)
      return
    }

    setFilteredContractors(
      contractors.filter(
        c =>
          c.name?.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
          (c.country && c.country.name && c.country.name.toLocaleLowerCase().includes(search.toLocaleLowerCase())) ||
          (c.accounts &&
            c.accounts.length > 0 &&
            c.accounts.filter(a => a.swift?.toLocaleLowerCase().includes(search.toLocaleLowerCase())).length > 0) ||
          (c.accounts &&
            c.accounts.length > 0 &&
            c.accounts.filter(a => a.currency?.toLocaleLowerCase().includes(search.toLocaleLowerCase())).length > 0)
      )
    )
  }, [search])

  useEffect(() => {
    getContractors()
  }, [])

  return (
    <>
      <MenuClient active={"contractor"} />
      <main className="main-container">
        <Header />

        <div className="container">
          <h1 className="ui-heading">Контрагенты</h1>
          <section className="header-chapter">
            <div className="headr-chapter-name">
              <div className="header-chapter-icon">
                <img src={IMG.requests} alt="" className="header-chapter-img" />
              </div>
              <h2 className="heading-chapter">Мои контрагенты</h2>
            </div>
            <Button
              id="new_contragent"
              onClick={() => navigate(CLIENT_CONTRACTOR_NEW_ROUTE)}
              leftIcon={<img src={IMG.plus_btn} alt="" className="img-btn" />}
            >
              Добавить
            </Button>
          </section>

          <section className="search-block">
            <Input
              type="search"
              onChange={e => setSearch(e.target.value)}
              placeholder="Поиск по названию, стране, SWIFT или валюте"
            />
          </section>

          <div className="main-content--wrapper">
            <section className="main-content">
              <ul className="header-global-list">
                <li className="header-global-item cols-contragent width-3-items">Название компании</li>
                <li className="header-global-item cols-contragent width-3-items">Страна</li>
                <li className="header-global-item cols-contragent width-3-items">Банк</li>
                <li className="header-global-item width-200">SWIFT</li>
                <li className="header-global-item width-130">Валюта</li>
              </ul>
              <ul className="global-list">
                {isLoading && (
                  <div className="skeleton-wrapper">
                    <Skeleton rows={4} gutterTop />
                  </div>
                )}
                {!isLoading &&
                  (filteredContractors.length > 0 ? (
                    filteredContractors.map((c, index) => (
                      <li
                        className="global-item"
                        id="deals-info-open"
                        key={index}
                        onClick={() => navigate(`/client/contractor/${c.id}`)}
                      >
                        <div className="global-scroll-block">
                          <p className="global-item-text cols-contragent width-3-items">{c.name}</p>
                          <p className="global-item-text cols-contragent width-3-items">{c.country?.name}</p>
                          <p className="global-item-text cols-contragent width-3-items">
                            {c.accounts && c.accounts.length > 0 ? c.accounts[0].bankName : "-"}
                          </p>
                          <p className="global-item-text width-200">
                            {c.accounts && c.accounts.length > 0 ? c.accounts[0].swift : "-"}
                          </p>
                          <p className="global-item-text width-130">
                            {c.accounts && c.accounts.length > 0 ? c.accounts[0].currency : "-"}
                          </p>
                        </div>
                      </li>
                    ))
                  ) : (
                    <EmptyRow text="Контрагентов не найдено" />
                  ))}
              </ul>
            </section>
          </div>
        </div>
      </main>
    </>
  )
}
